<template>
  <div class="_user-info-sessions">
    <div class="_sessions-top">
      <div class="_sessions-event-selector">
        筛选事件:
        <event-selector 
          v-model="filterEvent" 
          :extendEvents="extendEvents"
          @change="onChangeFilterEvent"></event-selector>
      </div>
      <div class="_sessions-chart">
        <div class="_to-chart" ref="toChart"></div>
        <div class="_sessions-chart-empty" v-if="!options.series.length">暂无数据</div>
      </div>
      <c-loading v-if="!ready"></c-loading>
    </div>
    <div class="_sessions-main-panel">
      <div class="_sessions-title-bar">
        <span class="_sessions-date">{{dateFormat(selectedDay)}}</span>
        <span class="_sessions-times">访问次数：<span style="margin-right: 5px">{{sessions.length}}</span>次</span>
      </div>
      <div class="_session-empty" v-if="!sessions.length && sessionsReady && ready">暂无数据</div>
      <template v-else>
        <c-loading v-if="!sessionsReady"></c-loading>
        <template v-else>
          <ul class="_sessions-list">
            <template v-for="session in sessions">
              <user-info-event
                :key="session.sessionId"
                isSession
                :uid="uid"
                :plat="session.platform"
                :sessionId="session.sessionId"
                :data="session"
              ></user-info-event>
              <user-info-event
                v-for="(event, i) in session.events"
                :data="event"
                :uid="uid"
                :plat="session.platform"
                :sessionId="session.sessionId"
                :highlight="filterEvent && filterEvent.event_id === event.eventId"
                :key="event.uuid + '_' + i"
              ></user-info-event>
              <div :key="session.sessionId + '_break'" class="_sessions-break"></div>
            </template>
          </ul>
        </template>
      </template>
    </div>
  </div>
</template>
<script>
import eventSelector from "../../components/eventSelector";
import echarts from "echarts";
import { mapState } from "vuex";
import { actions } from "../../store/constants";
import userInfoEvent from "./event";
import { util } from '../../utils';
let chart = null;
export default {
  name: "userInfoSessions",
  components: {
    eventSelector,
    userInfoEvent,
  },
  props: {
    uid: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      selectedDay: null,
      extendEvents: [{event_id: -100, event_name: '所有事件'}],
      filterEvent: {event_id: -100}
    }
  },
  computed: {
    ...mapState({
      sessions(state) {
        return state.bizUserInfo.sessions;
      },
      sessionDays(state) {
        return state.bizUserInfo.sessionDays
      },
      xAxis(state) {
        let xAxis = [];
        let xReady = false;
        let defaultDayId = null
        for (const p in this.sessionDays) {
          const list = this.sessionDays[p];
          list.forEach((item) => {
            if (!xReady) xAxis.push(item.dayId);
            if (item.numbers > 0) defaultDayId = item.dayId
          });
          xReady = true;
        }
        if (!this.selectedDay) this.selectedDay = defaultDayId
        return xAxis;
      },
      series(state) {
        let seriesList = [];
        for (const p in this.sessionDays) {
          const list = this.sessionDays[p];
          const series = {
            name: p,
            type: "bar",
            data: [],
          };
          list.forEach((item) => {
            series.data.push({
              value: item.numbers,
              itemStyle: {
                color:
                  Number(this.selectedDay) === item.dayId
                    ? "#F5BE49"
                    : "#FFECC1",
              },
              emphasis: {
                itemStyle: {
                  color: "#F5BE49",
                },
              },
            });
          });
          seriesList.push(series);
        }
        return seriesList;
      },
      options(state) {
        const options = {
          grid: {
            borderWidth: 0,
            x: 20,
            y: 0,
            y2: 40,
            x2: 20,
          },
          yAxis: [
            {
              type: "value",
              show: false,
            },
          ],
          tooltip: {
            show: true,
            trigger: "axis",
            axisPointer: {
              // 坐标轴指示器，坐标轴触发有效
              type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
              shadowStyle: {
                color: "rgba(218, 218, 218, 0.3)",
              },
            },
            backgroundColor: "rgba(0,0,0,0.5)",
            padding: [6, 10],
            textStyle: {
              fontsize: 16,
            },
            formatter: (seriesList) => {
              const res = [];
              seriesList.forEach((item) => {
                if (!res.length) res.push(this.dateFormat(item.name));
                res.push(
                  `${item.marker} ${item.seriesName}: ${item.data.value}次`
                );
              });
              return res.join("<br/>");
            },
          },
          xAxis: [
            {
              type: "category",
              data: this.xAxis,
              axisLabel: {
                show: true,
                interval: 29,
                textStyle: {
                  color: "#858585",
                  fontSize: 13,
                },
                formatter: (date) => {
                  return this.dateFormat(date);
                },
              },
              splitLine: {
                show: false,
              },
              axisLine: {
                show: true,
                lineStyle: {
                  color: "#eeeeee",
                },
              },
              axisTick: {
                show: false,
              },
            },
          ],
          series: this.series,
        };
        return options;
      },
      ready(state) {
        return (
          state.bizUserInfo.ready.sessionDays && state.bizSys.ready.eventGroups
        );
      },
      sessionsReady(state) {
        return !this.selectedDay || state.bizUserInfo.ready.sessions;
      },
    }),
  },
  watch: {
    ready(ready) {
      if (ready) this.initChart();
    },
    selectedDay() {
      this.getSessions();
    },
    uid() {
      this.filterEvent = {event_id: -100}
      this.getSessions()
    }
  },
  mounted() {
    if (this.ready) {
      this.initChart();
    }
  },
  beforeDestroy() {
    this.destroy();
  },
  methods: {
    destroy() {
      if (!chart) return;
      chart.dispose();
      chart = null;
    },
    initChart() {
      this.destroy();
      chart = echarts.init(this.$refs.toChart);
      chart.setOption(this.options);
      chart.on("click", (param) => {
        this.selectedDay = param.name;
        chart.setOption(this.options);
      });
    },
    getSessions() {
      const dayId = util.dateFormat(new Date(new Date().getTime() - util.dayTime), 'yyyymmdd')
      this.$store.dispatch(actions.userInfo.getSessions, {
        appId: this.appId,
        platform: this.platform,
        uidList: this.uid,
        beginDayId: this.selectedDay || dayId,
        cdpId: 0
      });
    },
    dateFormat(date) {
      if (!date) return "-";
      return (
        date.toString().replace(/\d{4}/, "").match(/\d{2}/g).join("月") + "日"
      );
    },
    onChangeFilterEvent() {
      const param = {
        appId: this.appId,
        platform: this.platform,
        uidList: this.uid,
        cdpId: 0
      }
      if (this.filterEvent.event_id > 0) param.eventId = this.filterEvent.event_id
      this.$store.dispatch(actions.userInfo.getInfo, param)
      .finally(() => {
        this.$nextTick(() => {
          this.initChart()
        })
      })
    }
  }
};
</script>
<style lang="sass">
@import './styles/sessions'
</style>